import React from "react";

export const Business = (props) => {
  return (
    <div id="business">
      <div className="container">
        <div className="section-title text-center">
          <h2>Sua empresa ainda não oferece um benefício de saúde ao colaborador?</h2>
          <h4>Fale conosco e assine a LuxVida Telemedicina agora mesmo!</h4>
          <h4>Email: contato@luxvidamed.com.br</h4>
          <h4>LUXVIDA GESTAO E SAUDE CNPJ: 27.264.067/0001-90</h4>
          
        </div>
      </div>
    </div>
  );
};
